var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurvedArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 73,
    viewBox: "0 0 20 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "CURVED ARROW",
    d: "M6.10041 0.00505358C5.55091 -0.0503999 5.06051 0.350099 5.00505 0.899593L4.10139 9.85411C4.04593 10.4036 4.44643 10.894 4.99593 10.9495C5.54542 11.0049 6.03583 10.6044 6.09128 10.0549L6.89454 2.09535L14.8541 2.89861C15.4036 2.95407 15.894 2.55357 15.9495 2.00407C16.0049 1.45458 15.6044 0.964174 15.0549 0.908721L6.10041 0.00505358ZM1.42976 72.4029C8.88205 68.856 16.393 58.396 18.9752 45.1661C21.5725 31.8587 19.2237 15.6113 6.77453 0.367465L5.22547 1.63253C17.2763 16.3887 19.5025 32.024 17.0122 44.783C14.5068 57.6194 7.26781 67.4094 0.570244 70.5971L1.42976 72.4029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedArrow);
export default __webpack_public_path__ + "static/media/CURVED-ARROW.2b238c8303e4b59c489f3e00528e50d3.svg";
export { ForwardRef as ReactComponent };